/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisputeSummary } from './DisputeSummary';
import {
    DisputeSummaryFromJSON,
    DisputeSummaryFromJSONTyped,
    DisputeSummaryToJSON,
    DisputeSummaryToJSONTyped,
} from './DisputeSummary';
import type { DisputeMatchResult } from './DisputeMatchResult';
import {
    DisputeMatchResultFromJSON,
    DisputeMatchResultFromJSONTyped,
    DisputeMatchResultToJSON,
    DisputeMatchResultToJSONTyped,
} from './DisputeMatchResult';

/**
 * Result of resolving a dispute
 * @export
 * @interface DisputeResolutionResponse
 */
export interface DisputeResolutionResponse {
    /**
     * 
     * @type {DisputeSummary}
     * @memberof DisputeResolutionResponse
     */
    dispute: DisputeSummary;
    /**
     * 
     * @type {DisputeMatchResult}
     * @memberof DisputeResolutionResponse
     */
    matchResult: DisputeMatchResult;
}

/**
 * Check if a given object implements the DisputeResolutionResponse interface.
 */
export function instanceOfDisputeResolutionResponse(value: object): value is DisputeResolutionResponse {
    if (!('dispute' in value) || value['dispute'] === undefined) return false;
    if (!('matchResult' in value) || value['matchResult'] === undefined) return false;
    return true;
}

export function DisputeResolutionResponseFromJSON(json: any): DisputeResolutionResponse {
    return DisputeResolutionResponseFromJSONTyped(json, false);
}

export function DisputeResolutionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeResolutionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dispute': DisputeSummaryFromJSON(json['dispute']),
        'matchResult': DisputeMatchResultFromJSON(json['matchResult']),
    };
}

export function DisputeResolutionResponseToJSON(json: any): DisputeResolutionResponse {
    return DisputeResolutionResponseToJSONTyped(json, false);
}

export function DisputeResolutionResponseToJSONTyped(value?: DisputeResolutionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dispute': DisputeSummaryToJSON(value['dispute']),
        'matchResult': DisputeMatchResultToJSON(value['matchResult']),
    };
}

